import DOMPurify from 'dompurify';

export const escapeHtml = (text: string): string => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
};

export const sanitizeRichHtml = (html: string): string => {
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            'br', 'a', 'b', 'strong', 'i', 'em', 'u', 'p',
            'ul', 'ol', 'li', 'span', 'div',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'blockquote', 'pre', 'code',
            'table', 'thead', 'tbody', 'tr', 'th', 'td',
        ],
        ALLOWED_ATTR: [
            'href', 'target', 'rel',
            'class', 'width', 'height',
            'colspan', 'rowspan',
        ],
    });
};
